import React from "react";

import { Typography, Box } from "@mui/material";

import styles from "./WalletHeading.module.css";

import solanaLogo from "../../../assets/images/wallets/solana.png";
import flowLogo from "../../../assets/images/wallets/flow.png";
import ethereumLogo from "../../../assets/images/wallets/ethereum.png";
import metamaskLogo from "../../../assets/images/wallets/metamask.png";
import nearLogo from "../../../assets/images/wallets/near.png";
import rainbowLogo from "../../../assets/images/wallets/rainbow.png";
import walletConnectLogo from "../../../assets/images/wallets/wallet_connect.png";
import bitcoinLogo from "../../../assets/images/wallets/bitcoin.png";

const logoMap = {
  solana: solanaLogo,
  bitcoin: bitcoinLogo,
  flow: flowLogo,
  metamask: metamaskLogo,
  ethereum: ethereumLogo,
  near: nearLogo,
  rainbow: rainbowLogo,
  wallet_connect: walletConnectLogo,
};

const WalletHeading = (props) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <Box mr={1}>
        <img src={logoMap[props.name] || props.logoUrl} alt="" className={styles.logo} />
      </Box>
      <Typography variant="h4" fontWeight="bold" textTransform="capitalize">
        {props.displayName}
      </Typography>
    </Box>
  );
};

export default WalletHeading;
